import { Paper } from '@mui/material';
import { Loader } from 'components';
import { useState } from 'react';
import { injectIntl } from 'react-intl';
import { ThemeSubjectActioner } from 'services/themeSubject';
import { ThemeSubjectForm } from './ThemeSubjectForm';

function ThemeSubjectEditComponent(props) {
  const [, reload] = useState();
  const id = props.match.params.id;
  const intl = props.intl.messages.scenes.subject.theme.edit;

  function editForm(values) {
    return <ThemeSubjectForm values={values} reload={() => reload({})} mode={'edit'} />;
  }

  function loadInfos() {
    return ThemeSubjectActioner.get(id)
      .then(infos => {
        const values = { ...infos, id };
        return values;
      })
      .catch(err => {
        throw err;
      });
  }

  function renderEditForm(render) {
    loadInfos().then(values => {
      render(editForm(values));
    });
  }

  return (
    <Paper className="padding-small">
      <h2 className="text-centered">{intl.title}</h2>
      <Loader render={renderEditForm} />
    </Paper>
  );
}

const ThemeSubjectEdit = injectIntl(ThemeSubjectEditComponent);

export { ThemeSubjectEdit };
